import React from 'react'

import { Row, Col, Form, Portlet } from '_zari/core'

import MarcaSection from './marcaSection'
import UbicacionSection from './ubicacionSection'
import CategoriaSection from './categoriaSection'

const portletBreadcrumbs = [{ name: 'Ingreso Masivo' }]

const IngresoMasivo = () => {
  const [tipoBusqueda, setTipoBusqueda] = React.useState('M')

  const changeTipoBusqueda = e => {
    setTipoBusqueda(e.target.value)
  }

  return (
    <>
      <Portlet>
        <Portlet.Header title='Ingreso Masivo' breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body>
          <Row>
            <Col md={4}>
              <Form.Group>
                <Form.Label text='TIPO' htmlFor='radio-tipoconsulta' md={2} />
                <Col md={3}>
                  <Form.Radio
                    name='radioTipo'
                    checked={'M' === tipoBusqueda}
                    value='M'
                    onChange={changeTipoBusqueda}
                    label='MARCAS'
                    id='radio-marcas'
                  />
                  <Form.Radio
                    name='radioTipo'
                    checked={'U' === tipoBusqueda}
                    value='U'
                    onChange={changeTipoBusqueda}
                    label='UBICACION'
                    id='radio-busqueda'
                  />
                  <Form.Radio
                    name='radioTipo'
                    checked={'C' === tipoBusqueda}
                    value='C'
                    onChange={changeTipoBusqueda}
                    label='CATEGORIAS'
                    id='radio-categorias'
                  />
                </Col>
              </Form.Group>
            </Col>
            <Col md={8}>
              {tipoBusqueda === 'M' && <MarcaSection />}
              {tipoBusqueda === 'U' && <UbicacionSection />}
              {tipoBusqueda === 'C' && <CategoriaSection />}
            </Col>
          </Row>
        </Portlet.Body>
      </Portlet>
    </>
  )
}

export default IngresoMasivo
